import { ActivityEntityName } from '../../../../entities';
import { MergeField, MergeSchema, getSchema } from '../../decorators';
import { ActivityMergeData, AttachmentMergeData } from './activity.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Invoice,
    name: 'InvoiceAttachmentsMergeDataSchema',
})
export class InvoiceAttachmentsMergeData {
    @MergeField({
        arraySchemaName: 'AttachmentMergeSchema',
        ignoreFields: ['thumbnail', 'shared', 'tags']
    })
    mediaAttachments: AttachmentMergeData[] = [];

    @MergeField({
        arraySchemaName: 'AttachmentMergeSchema',
        ignoreFields: ['thumbnail', 'shared', 'tags']
    })
    fileAttachments: AttachmentMergeData[] = [];
}

export const InvoiceAttachmentsMergeDataSchema = getSchema(InvoiceAttachmentsMergeData)

@MergeSchema({
    entity: ActivityEntityName.Invoice,
})
export class InvoiceActivitiesMergeData {
    @MergeField({
        arraySchemaName: 'ActivityMergeSchema'
    })
    activities: ActivityMergeData[] = [];
}

export const InvoiceActivitiesMergeDataSchema = getSchema(InvoiceActivitiesMergeData)